function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { T } from 'shared/helper/translate';
var DigitalTranslationsSurvey = function DigitalTranslationsSurvey(_ref) {
  var uuid = _ref.uuid,
    digitalTranslationsSurveyUrl = _ref.digitalTranslationsSurveyUrl;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    buttonDisplayed = _useState2[0],
    setButtonDisplayed = _useState2[1];
  useEffect(function () {
    // Copy-pasted from Typeform
    var d = document;
    var gi = d.getElementById;
    var ce = d.createElement;
    var gt = d.getElementsByTagName;
    var id = 'typef_orm_share';
    var b = 'https://embed.typeform.com/';
    if (!gi.call(d, id)) {
      var js = ce.call(d, 'script');
      js.id = id;
      js.src = "".concat(b, "embed.js");
      var q = gt.call(d, 'script')[0];
      q.parentNode.insertBefore(js, q);
    }
    setButtonDisplayed(true);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: "typeform-widget",
    style: {
      display: buttonDisplayed ? 'block' : 'none'
    },
    className: "text-center mb-3"
  }, /*#__PURE__*/React.createElement("a", {
    className: "typeform-share button btn btn-primary",
    href: "".concat(digitalTranslationsSurveyUrl, "&uuid=").concat(uuid),
    "data-mode": "drawer_right",
    "data-hide-headers": true,
    "data-hide-footer": true,
    "data-submit-close-delay": "2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Begin survey"
  })));
};
export default DigitalTranslationsSurvey;